import React from 'react';
import {
    Button,
    Navbar,
    Nav,
} from 'react-bootstrap';
import './navbar.scss'


const NavBarTest = (props) => {

    return (
        <Navbar style={{zIndex: 4}} className="navbar-bg-color" collapseOnSelect expand="md" bg="light" variant="light" fixed="top">
            <Navbar.Brand href="/">
                <img className="the-zimble-logo" src={require('../../icons/logo/Zimble_Word_Bluish.png')} alt="TheZimble Logo"/>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <div className="mr-auto"></div>
                <Nav className="mr-sm-4">
                    <Nav.Link href="/about">About Us</Nav.Link>
                    <Nav.Link href="/team">Meet the Team</Nav.Link>
                    <Nav.Link href="/usezimble">How to use Zimble</Nav.Link>
                </Nav>

                <Nav>
                    <Button href="/platform/questions" className="navbar-button"><span>Go to Platform</span></Button>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default NavBarTest;